<template>
  <v-main class="certification">
    <head>
      <meta name="viewport" content="width=device-width,initial-scale=1.0">
    </head>
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 320px) and (max-width: 639px)" >
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 640px) and (max-width: 1023px)" >
    <link href="desktop.css" rel="stylesheet" type="text/css" media="(min-width: 1024px)" >
    <v-card
      class="all mx-auto my-16 py-4 px-16 "
      width="1000"
      height="auto"
      color="white"
      elevation="0"
    >
    <div class="text-center">
      <div class="title1">入力した電話番号に認証番号を送信しました</div>
      <div class="pt-6 pb-8" style="font-size:14px;">
      入力した電話番号宛に送られたSMSにて受信した認証番号６桁を入力してください
      
      <v-card
      width="300"
      class="mx-auto"
      elevation="0"
      >
      <div class="phonenumber">認証番号</div>
        <vue-fake-input
          class="input"
          :length="6"
          :fontSize="30"
          inputColor="#2B2B2B"
          fontColor="#2B2B2B"
          :allowPaste="false"
          :onlyNumber="true"
          v-model="authenticationCode"
        />
      <div class="title3">半角英数字で入力</div>
      </v-card>
        <v-btn
          large
          outlined
          class="resend my-12 font-weight-bold"
          color="#399942"
          style="text-transform: none; font-family: mplus-2c-bold; font-size: 20px; border-width: 2px;"
          width="230px"
          href="/sms"
        >
          もう一度送信する
        </v-btn>
        <br>
        <v-btn
          id="send-code-button"
          large
          outlined
          class="my-12 font-weight-bold"
          color="#008CFF"
          style="text-transform: none; font-family: mplus-2c-bold; font-size: 20px; border-width: 2px;"
          width="230px"
          @click="confirmPhoneCode"
        >
          認証
        </v-btn>
      </div>
      <v-btn
        class="back"
        color="black"
        text
        large
        href="/sms"
        >
        <div class="a">
          <span style="color:#008CFF">＜</span> &nbsp; &nbsp;戻る &nbsp; &nbsp;<span style="color:#008CFF">＞</span>
        </div>
      </v-btn>
    </div>  
    </v-card>
  </v-main>
</template>

<script>
import firebase from 'firebase'
import VueFakeInput from 'vue-fake-input';

export default {
  components: {
    VueFakeInput
  },
  data: () => ({
    authenticationCode: '',
    confirmationResult: sessionStorage.getItem('result'),
    isLoading: false,
    result: null
  }),
  name: 'certification',
  mounted(){
    this.confirmationResult = sessionStorage.getItem('result')
    this.result = JSON.parse(this.confirmationResult)
    //console.log("大阪市中央区"+this.result,this.result.verificationId)
  },
  methods: {
  confirmPhoneCode() {
    //console.log("start認証"+firebase.auth.currentUser)
    if (!this.authenticationCode) {
      alert('認証コードを入力してください')
      return
    }
    this.isLoading = true
    const user = firebase.auth.currentUser
    const credential = firebase.auth.PhoneAuthProvider.credential(
      this.result.verificationId,
      this.authenticationCode
    )
    //console.log("start認証２"+credential+this.result.verificationId,this.authenticationCode+user)
    if (user) {
      //console.log("start認証3")
    user.linkWithCredential(credential).then(async (user) => {
          // 処理の実行
          //console.log(user)
          this.$router.push('smsfinish')
        })
        .catch((e) => {
          // エラーの処理
          alert("エラー")
          //console.log(e)
        })
      }
    else{
      alert("エラー")
    }}
  }
}
</script>

<style scoped>

*{
  font-family:mplus-2c-medium;
}
/*====================
PCを基本設計にする
 - 1280px〜：大型PC
 - 960px〜1279px：小型PC
 - 600px〜959px：タブレット
 - 480px〜599px：スマートフォン横
 - 〜479px：スマートフォン縦
====================*/

/* 1280px〜：大型PC
------------------------------ */
@media screen and (min-width:1280px) {
.all{
  position: relative;
  top:10%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 40px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 60px;
  left: -90px;
}
.title3{
  position: relative;
  left: 70px;
  top: 90px;
}
.input{
  position: relative;
  top: 80px
}
.resend{
  position: relative;
  top: 60px
}
.a{
  font-size:30px;
}
}

/* 960px〜1279px：小型PC
------------------------------ */
@media screen and (min-width:960px) and (max-width:1279px) {
.all{
  position: relative;
  top:0%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 38px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 60px;
  left: -90px;
}
.title3{
  position: relative;
  left: 70px;
  top: 90px;
}
.input{
  position: relative;
  top: 80px
}
.resend{
  position: relative;
  top: 60px
}
.a{
  font-size:25px;
}
}
/* 600px〜959px：タブレット
------------------------------ */
@media screen and (min-width:600px) and (max-width:959px) {
.all{
  position: relative;
  top:10%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 30px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 60px;
  left: -90px;
}
.title3{
  position: relative;
  left: 70px;
  top: 90px;
}
.input{
  position: relative;
  top: 80px
}
.resend{
  position: relative;
  top: 60px
}
.a{
  font-size:25px;
}
}

/* 480px〜599px：SP横
------------------------------ */
@media screen and (min-width:480px) and (max-width:599px) {
.all{
  position: relative;
  top:10%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 20px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 60px;
  left: -90px;
}
.title3{
  position: relative;
  left: 70px;
  top: 90px;
}
.input{
  position: relative;
  top: 80px
}
.resend{
  position: relative;
  top: 60px
}
.a{
  font-size:25px;
}
}

/* 〜479px：スマートフォン縦
------------------------------ */
@media screen and (max-width:479px) {
.all{
  position: relative;
  top:10%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 20px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 60px;
  left: -90px;
}
.title3{
  position: relative;
  left: 70px;
  top: 90px;
}
.input{
  position: relative;
  top: 80px
}
.resend{
  position: relative;
  top: 60px
}
.a{
  font-size:25px;
}
}


</style>